import { API, marketplaceServiceUrl } from '@labrav/common'

export const fetchCppoAgreementData = (
  parnterId: string,
  crmAwsResellerAgreementId: string,
  secureKey: string,
  email?: string
) => {
  return API.get(
    `${marketplaceServiceUrl}/v1/partners/${parnterId}/aws_reseller_agreements/${crmAwsResellerAgreementId}`,
    {
      params: {
        email,
        s: secureKey,
      },
    }
  )
}
